import React from 'react';
import { AdaptiveFilterBar } from '../../../shared/components/patterns';

const staffFilterConfig = {
  search: {
    key: 'query',
    placeholder: 'Cerca per nome o ruolo...',
  },
  groups: [
    {
      key: 'tipo',
      label: 'Tipo personale',
      selection: 'single',
      emptyValue: 'tutti',
      options: [
        { value: 'interno', label: 'Interno' },
        { value: 'esterno', label: 'Esterno' },
      ],
    },
  ],
};

export default function StaffFilters({
  searchTerm,
  onSearchChange,
  filterTipo,
  onFilterTipoChange,
  activity,
}) {
  return (
    <AdaptiveFilterBar
      config={{ ...staffFilterConfig, groups: [...staffFilterConfig.groups, ...(activity ? [activity.filterGroup] : [])] }}
      values={{ query: searchTerm, tipo: filterTipo, activity: activity?.overview || '' }}
      onChange={(key, value) => {
        if (key === 'query') onSearchChange(value);
        if (key === 'tipo') onFilterTipoChange(value || 'tutti');
        if (key === 'activity') activity?.setFilter(value);
      }}
      onReset={() => {
        onSearchChange('');
        onFilterTipoChange('tutti');
        activity?.reset();
      }}
    />
  );
}
